import { NgClass, NgFor, NgForOf } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-table-generic-button',
  standalone: true,
  imports: [NgClass],
  templateUrl: './app-table-generic-button.component.html',
  styleUrl: './app-table-generic-button.component.scss'
})
export class AppTableGenericButtonComponent {
  @Input() id: string = '';
  @Input() label: string = '';
  @Input() icon: string = '';
  @Output() clicked = new EventEmitter<void>();

  constructor() {}

  handleClick() {
    this.clicked.emit();
  }
}
